import { Controller } from 'react-hook-form';
import css from './index.module.scss';
import { SelectLabel, TextField } from '@components/common';
import { useState } from 'react';

interface IQuotePackageWrapperProps {
  label: React.ReactNode;
  control: any;
  currency?: string;
  currencyLabel?: string;
  currencyOptions?: any[];
  currencyPlaceholder?: string;
  currencyOnChange?: () => void;
  input?: string;
  inputLabel?: string;
  inputPlaceholder?: string;
  inputOnChange?: () => void;
  inputRequired?: boolean;
  unit?: string;
  unitLabel?: string;
  unitOptions?: any[];
  unitPlaceholder?: string;
  unitOnChange?: () => void;
}

const QuotePricePackageWrapper = (props: IQuotePackageWrapperProps) => {
  const {
    control,
    label,
    // Currency props
    currency,
    currencyLabel,
    currencyOptions = [],
    currencyPlaceholder,
    currencyOnChange,
    // Input props
    input,
    inputLabel,
    inputPlaceholder,
    inputOnChange,
    inputRequired = false,
    // Unit props
    unit,
    unitLabel,
    unitOptions = [],
    unitPlaceholder,
    unitOnChange
  } = props;

  const showAsterisk = inputRequired && input ? ' *' : '';

  const [error, setError] = useState('');

  const renderCurrencySelect = () => (
    <div className={`${css.contentWrapperItem} ${css.contentWrapperSelect}`}>
      <Controller
        name={currency!}
        control={control}
        render={({ field, fieldState }) => (
          <SelectLabel
            {...field}
            options={currencyOptions}
            placeholder={currencyPlaceholder}
            hideBorder={true}
            label={currencyLabel}
            onChange={(e) => {
              currencyOnChange?.();
              field.onChange(e);
            }}
            className={css.selectLabel}
            disableIsFocused={true}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </div>
  );

  const renderTextInput = () => (
    <div className={`${css.contentWrapperItem} ${css.contentWrapperInput}`}>
      <Controller
        name={input!}
        control={control}
        render={({ field, fieldState }) => {
          if (fieldState.error?.message !== error) {
            setError(fieldState.error?.message || '');
          }

          return (
            <TextField
              {...field}
              value={
                field.value !== null && field.value !== undefined && field.value !== ''
                  ? typeof field.value === 'number'
                    ? field.value.toFixed(2)
                    : String(field.value)
                  : ''
              }
              label={inputLabel}
              hideBorder={true}
              placeholder={inputPlaceholder}
              onChange={(e) => {
                inputOnChange?.();
                field.onChange(e);
              }}
              error={fieldState.invalid}
              required={inputRequired}
            />
          );
        }}
      />
    </div>
  );

  const renderUnitSelect = () => (
    <div className={`${css.contentWrapperItem} ${css.contentWrapperSelect}`}>
      <Controller
        name={unit!}
        control={control}
        render={({ field, fieldState }) => (
          <SelectLabel
            {...field}
            label={unitLabel}
            options={unitOptions}
            placeholder={unitPlaceholder}
            hideBorder={true}
            onChange={(e) => {
              unitOnChange?.();
              field.onChange(e);
            }}
            className={css.selectLabel}
            disableIsFocused={true}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </div>
  );

  return (
    <main className={css.mainWrapper}>
      {label && (
        <div className={css.mainWrapperLabel} data-value={showAsterisk}>
          {label}
          {showAsterisk && <span className={css.asterisk}>*</span>}
        </div>
      )}
      <div className={`${css.contentWrapper} ${error.length > 0 ? css.contentWrapperError : ''}`}>
        {currency && renderCurrencySelect()}
        {input && renderTextInput()}
        {unit && renderUnitSelect()}
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </main>
  );
};

export default QuotePricePackageWrapper;
